import React from "react";
import ReactDOM from "react-dom/client";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";
import { bootstrap } from "@ms-fabric/workload-client";
import { App } from "./App";

// Defence-in-depth: if loaded as the AAD popup reply URI, just close.
const REDIRECT_URI_PATH = "/close";
if (window.location.pathname.startsWith(REDIRECT_URI_PATH)) {
  window.close();
} else {
  // Fabric loads the workload twice per session: first as an invisible
  // worker iframe (initializeWorker), then again as one or more visible
  // UI iframes (initializeUI). bootstrap() detects which mode this load
  // is in and signals readiness back to the host so the host will spawn
  // the editor iframe at the path declared in the item manifest.
  bootstrap({
    initializeWorker: async () => {
      // Worker iframe: nothing to register beyond default handlers.
    },
    initializeUI: async () => {
      ReactDOM.createRoot(document.getElementById("root")!).render(
        <React.StrictMode>
          <FluentProvider theme={webLightTheme}>
            <App />
          </FluentProvider>
        </React.StrictMode>
      );
    }
  });
}
